/*=========================================================================================
  File Name: moduleReportFormConfig.js
  Description: Request Type Config Module

==========================================================================================*/

import state from "./moduleReportFormConfigState.js";
import mutations from "./moduleReportFormConfigMutations.js";
import actions from "./moduleReportFormConfigActions.js";
import getters from "./moduleReportFormConfigGetters.js";

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
